import React, { useState } from "react";
import { View, TouchableOpacity, Text, ActivityIndicator } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useNavigation } from "@react-navigation/native";
import { FormattedMessage, useIntl } from "react-intl";
import { If, Else } from "react-if";

import HeaderTabs from "../../components/HeaderTabs";
import { toast } from "../../utils/toast";

import api from "../../services/api";

import styles from "./styles";

const DeleteAccount = () => {
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState(false);
  const navigation = useNavigation();

  const deleteAccount = async () => {
    setIsLoading(true);
    const token = await AsyncStorage.getItem("JWT_TOKEN");

    api
      .delete(`/clients/delete/client`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        toast(
          intl.formatMessage({ id: "deleteAccount.contaExcluida" }),
          "#080"
        );

        setIsLoading(false);
        navigation.navigate("Login");
      })
      .catch((error) => {
        console.log(error);
        toast(intl.formatMessage({ id: "deleteAccount.erroGeral" }), "#DA1414");
        setIsLoading(false);
      });
  };
  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="deleteAccount.headerExcluiConta" />}
      />

      <Text style={styles.textInfo}>
        <FormattedMessage id="deleteAccount.msgCertezaExcluiConta" />
      </Text>

      <View style={styles.contentBtn}>
        <TouchableOpacity onPress={deleteAccount} style={styles.btn}>
          <If condition={isLoading}>
            <ActivityIndicator color="#fff" size="small" />
          </If>
          <Else>
            <Text style={styles.textBtn}>
              <FormattedMessage id="deleteAccount.excluir" />
            </Text>
          </Else>
        </TouchableOpacity>
      </View>
    </>
  );
};

export default DeleteAccount;
